import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { RepassesPesquisaComponent } from './repasses-pesquisa/repasses-pesquisa.component';

import { SharedsModule } from '../shareds/shareds.module';

@NgModule({
  imports: [
    SharedsModule,
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [RepassesPesquisaComponent]
})
export class RepassesModule { }
